import React, { useContext, useState } from 'react';
import { PlanningEtapesContext } from './PlanningEtapes';
import { jourFr } from './PlanningPreparer';
import { planningAPI } from '../services/api';

/**
 * Le bandeau « N dates à vérifier » du Calendrier — lot PA.2 (maquette « préparer
 * l'année »). Après une préparation à partir d'une année précédente, les dates
 * décalées qui tombent un jour férié ou pendant des vacances sont listées ici, ainsi
 * que celles qui n'ont pas été reprises parce qu'elles sortaient de l'année.
 * « C'est vérifié » le retire pour TOUT le département (décidé le 28/10) ; le
 * journal garde qui et quand. Il lit l'état déjà chargé par le module (contexte) :
 * pas de requête de plus à l'ouverture du calendrier.
 */
const plage = (p) => jourFr(p.debut) + (p.fin && p.fin !== p.debut ? ' → ' + jourFr(p.fin) : '');
const quoi = (x) => (x.quoi === 'periode' ? 'Période' : 'Événement') + ' « ' + x.libelle + ' »';

function PlanningAVerifier({ departementId, peutEcrire }) {
    const { etat, rafraichir } = useContext(PlanningEtapesContext);
    const [ouvert, setOuvert] = useState(false);
    const [erreur, setErreur] = useState('');
    const [enCours, setEnCours] = useState(false);
    const a = etat?.aVerifier;
    if (!a) return null;

    const verifiee = async () => {
        setEnCours(true); setErreur('');
        try {
            await planningAPI.marquerVerifiee(a.id, departementId);
            await rafraichir();
        } catch (err) {
            setErreur(err?.response?.data?.error || err.message);
        } finally {
            setEnCours(false);
        }
    };

    const n = a.liste.length;
    const m = a.nonReprises.length;
    return (
        <div className="pl-averifier">
            <i className="fa-solid fa-triangle-exclamation" />
            <span>
                {n > 0 && <b>{n} date{n > 1 ? 's' : ''} à vérifier</b>}
                {n > 0 && m > 0 && ' · '}
                {m > 0 && <b>{m} non reprise{m > 1 ? 's' : ''}</b>}
                {' '}— année préparée à partir de {a.source} (décalage de {a.semaines} semaines) par {a.auteur}.
            </span>
            <span className="gestes">
                <button className="pl-btn pl-btn-sm" onClick={() => setOuvert(!ouvert)}>
                    <i className="fa-solid fa-list" /> {ouvert ? 'Masquer la liste' : 'Voir la liste'}
                </button>
                <button className="pl-btn pl-btn-sm" onClick={verifiee} disabled={!peutEcrire || enCours}
                    title={peutEcrire ? 'Retire ce bandeau pour tout le département' : 'Il faut le droit « modifier » sur le Planning annuel'}>
                    <i className="fa-solid fa-check" /> C'est vérifié
                </button>
            </span>
            {erreur && <div className="liste">Échec : {erreur}</div>}
            {ouvert && (
                <div className="liste">
                    {a.liste.map((x, i) => (
                        <div key={'v' + i}>• {quoi(x)} — {plage(x.apres)} : <b>{x.motif}</b></div>
                    ))}
                    {a.nonReprises.map((x, i) => (
                        <div key={'n' + i}>• {quoi(x)} du {plage(x.avant)} : <b>non reprise</b>, elle serait tombée le {plage(x.apres)}, {x.motif}</div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default PlanningAVerifier;
